import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { BASE_URL } from './apiConfig';
import { RotateSpinner } from "react-spinners-kit";
import './CommonCSS.css'

export default function APIKeyGenerate() {
    const [isIPCheckRequired, setIsIPCheckRequired] = useState(false);
    const [showprogress, setshowprogress] = useState(false);
    const [apikeygenerated, setapikeygenerated] = useState('');
    // const [apipasswordgenerated, setapipasswordgenerated] = useState('');
    // const [apiusernameinput, setapiusernameinput] = useState('');
    const [isshorturl, setisshorturl] = useState("");
    const [shorturldomain, setshorturldomain] = useState("");
    const [distinctdomain, setdistinctdomain] = useState([]);

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionguiuser = loginData?.guiuserid;
    const sessionapiusername = loginData?.apiuserid;

    const handleCheckboxChange = (event) => {
        setIsIPCheckRequired(event.target.checked);
    };

    // const handleInputChange = (event) => {
    //     const value = event.target.value;
    //     if (/^[a-zA-Z]*$/.test(value) && value.length <= 45) {
    //         setapiusernameinput(value);
    //     }
    // };

    console.log("isiptocheck:" + isIPCheckRequired);
    //  console.log("Secondary API User ID:" + apiusernameinput);
    console.log("Secondary API Key:" + apikeygenerated);
    // console.log("Secondary API Password:" + apikeygenerated);


    const CallAPIKeyGenerate = async () => {
        if (!isshorturl || (isshorturl === "1" && shorturldomain === "")) {
            setshowprogress(false);
            console.error("Please fill in all fields");
            Swal.fire({
                title: 'Error Occurred',
                html: 'Please Check Either Is Shorturl or URL Domain is not Selected',
                icon: 'error'
            });
        }

        else {
            try {
                setshowprogress(true);
                const apiUrl = `${BASE_URL}/NewAPIGenerate`;

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        guiuserid: sessionguiuser,
                        isiptocheck: String(isIPCheckRequired),
                        isshorturl: isshorturl === "1" ? 1 : 0,
                        shortUrlDomain: shorturldomain
                        // suid: apiusernameinput
                    }),
                });

                if (!response.ok) {

                    const errorMessage = response.statusText;
                    const responseBody = await response.text();
                    setshowprogress(false);
                    const result = await Swal.fire({
                        title: 'APIKey Generating Error',
                        html: `${errorMessage}${responseBody}`,
                        icon: 'error'
                    });

                    if (result.isConfirmed) {
                        setIsIPCheckRequired(false);
                        setapikeygenerated('No API Key Generated');
                        setisshorturl("");
                        setshorturldomain("");
                        // setapipasswordgenerated('No API Password Generated');
                    }
                    return;
                }

                else {

                    const data = await response.json();
                    console.log(data);
                    console.log("Inside Secondary API Key:" + data?.genertaedSkey);
                    console.log("Inside Secondary API Password:" + data?.generatedSpassword);

                    setshowprogress(false);
                    const result = await Swal.fire({
                        title: "Inserted Successfully!",
                        text: `Your New API Key ${data?.genertaedSkey} has been Generated Successfully.`,
                        icon: "success"
                    });
                    if (result.isConfirmed) {
                        setapikeygenerated(data?.genertaedSkey);
                          setisshorturl("");
                        setshorturldomain("");
                        setIsIPCheckRequired(false);
                        // setapipasswordgenerated(data?.generatedSpassword);
                    }
                }
            }

            catch (error) {
                console.error("API Request Error:", error.message);
                setshowprogress(false);

                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: error.message,
                    icon: 'error'
                });
                if (result.isConfirmed) {
                    setIsIPCheckRequired(false);
                    setapikeygenerated('No API Key Generated');
                    //setapipasswordgenerated('No API Password Generated');
                }
                return;
            }
        }
    }

    const callDistinctShortDomain = async () => {
        const apiUrl = `${BASE_URL}/GetDomainList`;

        const fetchOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        setshowprogress(true);
        try {

            const response = await fetch(apiUrl, fetchOptions);
            setshowprogress(false);
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            const data = await response.json();
            setdistinctdomain(data);

        } catch (error) {
            setshowprogress(false);
            console.error("API Request Error:", error.message);
        }
    };

    useEffect(() => {
        callDistinctShortDomain();
    }, []);



    return (
        <div className="maincontent-outermost" style={{fontSize:"0.8rem"}}>
            <div className="div-container">
                <div className="row-container">
                    <span>Generate New API Key</span>
                </div>

                <div className="row-container">
                    <div className="row-left-div " style={{ position: "relative" }}>
                        {showprogress === true ? <div className="spinner-overlay">
                            <div className="custom-spinner"></div>
                        </div> : <div></div>}
                        <div className={showprogress === true ? "div blurred" : "div"}>
                            <diV className="row-container left-div-img" style={{ justifyContent: "center", }}>
                                <img src="/images/keyword.png" style={{ width: "7rem", height: "7rem" }} />
                            </diV>

                            <div className="row-container mt-3" >
                                <label style={{ fontWeight: "600", marginRight: "1.9rem" }} className="label">API User ID</label>
                                <div style={{ display: "flex" }} className="inp">
                                    <input type="text" className="form-control " disabled style={{ fontSize: "0.9rem" }} value={sessionapiusername} />
                                </div>
                                <div style={{ alignItems: "center", border: "1px solid rgb(179, 176, 176)", backgroundColor: "rgb(179, 176, 176)", justifyContent: "center", padding: "0rem 0.5rem" }} className="ic-div">
                                    <i className="fa-solid fa-key "></i>
                                </div>
                            </div>

                            <div className="row-container mt-3" >
                                <label style={{ fontWeight: "600", marginRight: "1.2rem" }} className="label">New API Key</label>
                                <div style={{ display: "flex" }} className="inp">
                                    <input type="text" className="form-control " value={apikeygenerated} disabled style={{ fontSize: "0.9rem" }} placeholder="Click on the button to Generate API Key" />
                                </div>
                                <div style={{ alignItems: "center", border: "1px solid rgb(179, 176, 176)", backgroundColor: "rgb(179, 176, 176)", justifyContent: "center", padding: "0rem 0.5rem" }} className="ic-div">
                                    <i className="fa-solid fa-key "></i>
                                </div>
                            </div>

                            <div className="row-container mt-3" >
                                <label style={{ fontWeight: "600", marginRight: "1.6rem", marginTop: "0.4rem" }} className="label">Is ShortURL</label>
                                <div style={{ display: "flex" }} className="inp">
                                    <select
                                        className="selectpicker form-control"
                                        value={isshorturl}
                                        onChange={(e) => setisshorturl(e.target.value)}
                                        style={{ textOverflow: "ellipsis", fontSize:"0.85rem",overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                    >
                                        <option value="">Select Is ShortURL Enable</option>
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>
                                </div>
                                <div style={{ alignItems: "center", border: "1px solid rgb(179, 176, 176)", backgroundColor: "rgb(179, 176, 176)", justifyContent: "center", padding: "0rem 0.5rem" }} className="ic-div">
                                    <i class="fa-solid fa-link"></i>
                                </div>
                            </div>

                            <div className="row-container mt-3" >
                                <label style={{ fontWeight: "600", marginRight: "1.2rem", marginTop: "0.4rem" }} className="label">URL Domain</label>
                                <div style={{ display: "flex" }} className="inp">
                                    <select
                                        className="selectpicker form-control"
                                        value={shorturldomain}
                                        onChange={(e) => setshorturldomain(e.target.value)}
                                        style={{
                                            fontSize: "0.8rem",
                                            textOverflow: "ellipsis",
                                            overflowWrap: "break-word",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                        }}
                                        disabled={isshorturl === "0" || isshorturl === "" || distinctdomain?.length === 0} // Disable the dropdown if guiuser is "All"
                                    >
                                        <option value="" disabled>Select ShortURL Domain</option>
                                        {distinctdomain?.map((option, index) => (
                                            <option
                                                key={index}
                                                value={option}

                                            >{option}</option>
                                        ))}
                                    </select>
                                </div>
                                <div style={{ alignItems: "center", border: "1px solid rgb(179, 176, 176)", backgroundColor: "rgb(179, 176, 176)", justifyContent: "center", padding: "0rem 0.5rem" }} className="ic-div">
                                    <i class="fa-solid fa-earth-americas"></i>
                                </div>
                            </div>

                            <div className="row-container mt-4" style={{justifyContent:"flex-start"}}>
                                <div className="checkbox-wrapper-12 mr-2">
                                    <div className="cbx">
                                        <input
                                            id="cbx-12"
                                            type="checkbox"
                                            checked={isIPCheckRequired}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label htmlFor="cbx-12"></label>
                                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none">
                                            <path d="M2 8.36364L6.23077 12L13 2"></path>
                                        </svg>
                                    </div>

                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                                        <defs>
                                            <filter id="goo-12">
                                                <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur"></feGaussianBlur>
                                                <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -7" result="goo-12"></feColorMatrix>
                                                <feBlend in="SourceGraphic" in2="goo-12"></feBlend>
                                            </filter>
                                        </defs>
                                    </svg>
                                </div>

                                <span style={{ fontWeight: '500', fontSize: '0.97rem' }}>Is IP Check Required</span>
                            </div>

                            <div className="row-container mt-4 mb-4" style={{ justifyContent: "center" }}>
                                <button type="submit" className="btn  btn-info pl-4 pr-4" onClick={CallAPIKeyGenerate}>Generate New API Key
                                    <img src="images/iconbuttonkey.png" style={{ height: "1.4rem", width: "1.4rem" }} className="ml-1" />
                                </button>
                            </div>


                        </div>
                    </div>

                    <div className="row-right-div">
                        <img src="images/apikey.jpeg" />
                    </div>
                </div>
            </div>
        </div>
    );
}